import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let image_id = useDataValue({
    path: '_id',
    context: 'patient_image',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      image_id,
    },
    requestPolicy: 'cache-and-network',
  }
}
